import React, { Component } from 'react';
import './Breadcrumb.css';
import { Translations, convertStringToArray } from '../../../utils/';

class Breadcrumb extends Component {

  translations = (text) => {
    return Translations(text, this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }
  translateWord = (word) => {
    var currentWord = Translations(word, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArray(currentWord);
    return convertedArray;
  }
  render() {
    return (
      <div className='breadcrumb'>
        <ul>
          {
            this.props.isClientImplementationManager ?
              <li className={"firstElement" + (this.props.steps > 0 ? " selected" : "")}><a aria-hidden="true" tabIndex="-1" href="javascript:void(0)"><span className="boldNum">1.</span> {this.translateWord(this.props.BreadcrumbpageJson.par.breadcrumb_mainBreadcrumb.text)[0]}</a></li>
              :
              <React.Fragment>
                <li className={"firstElement" + (this.props.steps > 0 ? " selected" : "")}><a aria-hidden="true" tabIndex="-1" href="javascript:void(0)"><span className="boldNum">1.</span> {this.translateWord(this.props.BreadcrumbpageJson.par.breadcrumb_mainBreadcrumb.text)[0]}</a></li>
                <li className={(this.props.steps > 1 ? " selected" : "")}><a tabIndex="-1" aria-hidden="true" href="javascript:void(0)"><span className="boldNum">2.</span> {this.translateWord(this.props.BreadcrumbpageJson.par.breadcrumb_mainBreadcrumb.text)[1]}</a></li>
                <li className={(this.props.steps > 2 ? " selected" : "")}><a tabIndex="-1" aria-hidden="true" href="javascript:void(0)"><span className="boldNum">3.</span> {this.translateWord(this.props.BreadcrumbpageJson.par.breadcrumb_mainBreadcrumb.text)[2]}</a></li>
                <li className={(this.props.steps > 3 ? " selected" : "")}><a tabIndex="-1" aria-hidden="true" href="javascript:void(0)" className="lastElement"><span className="boldNum">4.</span> {this.translateWord(this.props.BreadcrumbpageJson.par.breadcrumb_mainBreadcrumb.text)[3]}</a></li>

              </React.Fragment>
          }
        </ul>
      </div>
    );
  }
}
export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/components/common/Breadcrumb/Breadcrumb.js